import { Box } from "@mui/system";
import React from "react";
import Banner from "../Component/Homepage Components/Banner/Banner";
import BrowseSkill from "../Component/Homepage Components/BrowseSkills/BrowseSkill";
import Categories from "../Component/Homepage Components/Categories/Categories";
import Agency from "../Component/Homepage Components/Agency/Agency";
import Freelancer from "../Component/Homepage Components/Freelancer/Freelancer";
import GetStarted from "../Component/Get Started/GetStarted";
import Keypoints from "../Component/Homepage Components/Keypoints/Keypoints";
import LatestBlogNews from "../Component/Homepage Components/LatestBlogNews/LatestBlogNews";
import StartEarning from "../Component/Homepage Components/Start Earning/StartEarning";
import Testimonial from "../Component/Homepage Components/Testimonial/Testimonial";
import TrendingServices from "../Component/Homepage Components/Trending Services/TrendingServices";
import TopClientConnect from "../Component/Homepage Components/TopClientConnect/TopClientConnect";
import HomePageJobs from "../Component/Homepage Components/HomePageJobs";

const Home = () => {
  function getCookie(name) {
    const value = document.cookie
      .split("; ")
      .find((row) => row.startsWith(name + "="));
    return value ? decodeURIComponent(value.split("=")[1]) : null;
  }

  const user = getCookie("songjukti_user")
    ? JSON.parse(getCookie("songjukti_user"))
    : null;

  if (user) {
    localStorage.setItem("songjukti_user", JSON.stringify(user));
    localStorage.setItem("gh_sl@g", btoa(user));
  }

  return (
    <Box>
      <Banner />
      <Keypoints />
      <Categories />
      <TrendingServices />
      <Freelancer />
      <StartEarning />
      <HomePageJobs />
      <Testimonial />
      <Agency />
      <LatestBlogNews />
      <TopClientConnect />
      <BrowseSkill />
      <GetStarted />
    </Box>
  );
};

export default Home;